module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C841"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "C782"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_Tablet#page_1"
    }
  }, [_vm._v("Tablet")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_Possible#page_2"
    }
  }, [_vm._v("Possible Psalm")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_Serotoni#page_3"
    }
  }, [_vm._v("Serotonin")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_Or_a_Wom#page_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Or a Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_Brief_Dr#page_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brief Dream of Bronwyn Rae")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_Poem_Wri#page_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poem Written in the Heliopause")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_Eavesdri#page_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eavesdripping Hour, Sunday Afternoon")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_My_Recen#page_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Recently Implanted Gov’t Eco Guilt Chip")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_In_the_W#page_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Weeks before You Were Born, Driving through the Mission Valley, He Watches Her Begin a List for Labor")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_Vows___#page_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vows")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_Blown_Sn#page_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blown Snow")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_Strange#page_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strange Lullaby")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_Not_Know#page_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not Knowledge")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_Sustenan#page_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sustenance")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_Partial#page_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Partial Eclipse N 46.677, W 114.244")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/22_Windowsi#page_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Windowsill")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/23_Tarnatio#page_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tarnation")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/24_Weekly_A#page_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Weekly Apocalyptic or Poem Written on the Wall in an Ascending Space Capsule")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/25_May_____#page_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/26_That_Blu#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("That Blue")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/27_I_Canoni#page_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Canonize Dick Curran")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/28_They_Tie#page_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Tied the Madmen to Trees beside the River and All the Shrinks Went Out of Business")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/29_Ghazal_i#page_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghazal in Which End Word Repetition Is Implied")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/30_Inscript#page_37",
      "id": "page_x",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inscription")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/31_Septembe#page_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September Miniatures with Blood and Mars")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/32_The_Taxi#page_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Taxidermist’s Answers")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/33_Hammock#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hammock Poem")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/34_Stubborn#page_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stubborn Poem")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/35_Nostrums#page_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nostrums (Bill Monroe)")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/36_Things_B#page_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Things Boys Paint")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/37_Comes_to#page_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comes to Worse")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/38_February#page_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("February Sidereal with Backyard Doe")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/39_Still_Li#page_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Still Life with Starlight")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/40_Study_fo#page_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Study for Acrylic of Sleeman Peak Dusk with Wildflowers")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/41_Poem_wit#page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poem with Several Keatsian References, Poem Burning Up in the Fire I Lit to Warm My Son, or Do as I Say Not as I Do")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/42_Winterin#page_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wintering")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/43_Fluvial_#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fluvial")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/44_The_Roof#page_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Roofers Listen to Heart’s “Crazy on You” as They Work")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/45_Vespers#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vespers Beginning as Sheep Tallow in the Hands of a Priest")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/46_The_Forb#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Forbidden")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/47_Small_Fi#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Small Fire in Snow")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/48_Naive_Me#page_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Naïve Melody")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/49_Grove#page_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grove")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/50_Trimming#page_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trimmings")])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('span', {
    attrs: {
      "href": "#/html/51_A_Toast#page_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "C782"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/52_Notes#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C784"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/53_Acknowle#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3751a9c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_Contents.vue
// module id = 72
// module chunks = 0